import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import FormInput from './FormInput';
import EncabezadoAdmin from './EncabezadoAdmin';
import BtnGuardarEdit from './BtnGuardarEdit';
import { arreglarReloj, handleError, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig';
import { ContainerAdmin } from './ContainerAdmin';
import { ContainerAdminN } from './ContainerAdminN';
import { useAnimatedMount } from '../hooks/useAnimatedMount';

function CrearReunion(props) {
    const [horaFin, setHoraFin] = useState("17:00");
    const [horaInicio, setHoraInicio] = useState("08:00");
    const [idInscripcion1, setIdInscripcion1] = useState("-1");
    const [idInscripcion2, setIdInscripcion2] = useState("-1");
    const [mesa, setMesa] = useState({ id: "", numeroDeMesa: "0" });
    const [reloadCount, setReloadCount] = useState(0);
    const { mounted, visible } = useAnimatedMount(props.show);

    const [paramsEventoTurno, setParamsEventoTurno] = useState({
        params: {
            eventoId: '',
            horaInicio: '08:00'
        }
    });

    function crearReunion() {

        if (idInscripcion1 === "-1" || idInscripcion2 === "-1") {
            toastError("Debe seleccionar una empresa válida");
        }
        else if (idInscripcion1 === idInscripcion2) {
            toastError("Debe seleccionar empresas distintas");
        }
        else {
            const params = {
                horaInicio: horaInicio,
                horaFin: horaFin,
                inscripciones: [
                    { id: idInscripcion1 },
                    { id: idInscripcion2 }
                ],
                numeroMesa: mesa.numeroDeMesa
            }
            axios
                .post(process.env.REACT_APP_URL + 'reunion?mesaId=' + mesa.id, params)
                .then((res) => {
                    setHora(props.horarios[0])
                    setMesa({ id: "", numeroDeMesa: "0" });
                    setReloadCount(prev => prev + 1)
                    setIdInscripcion1(props.empresas[0].inscripcionView.id);
                    setIdInscripcion2(props.empresas[0].inscripcionView.id);
                    toastSuccess("Reunión creada")
                    //props.cambiarReuniones("", 1)
                    props.cambiarReuniones()
                })
                .catch(function (error) {
                    toastError(handleError(error))
                })
        }

    }

    useEffect(() => {
        if (props.evento !== '' && props.evento !== undefined) {
            setParamsEventoTurno({
                params: {
                    eventoId: props.evento,
                    horaInicio: horaInicio
                }
            })
        }
    }, [props.evento, horaInicio])
    function setHora(hora) {
        const horarios = hora.split(" / ");
        setHoraInicio(horarios[0])
        setHoraFin(horarios[1])
    }
    return (

        <>
            {mounted && <>
                <ContainerAdminN id={"containerCrear"} className={`transition-all-1s shadowAdmin crearReunion ${visible ? "transform-none" : ''}`} mainContent={
                    paramsEventoTurno.params.eventoId !== '' ?
                        <>
                            <EncabezadoAdmin subtitulo={'Ingrese los datos de la reunión que desea crear'} titulo={'Crear reunión'} />
                            <div id="datosEmpresa">
                                <div className='row'>
                                    <FormInput id={"horario"} text={"Horario"} className={"col-md-5 col-12 offset-sm-1 col-sm-10 "}
                                        mostrarTodas={true} idSeccion={10} setValue={setHora} items={props.horarios} isText={true} value={horaInicio + " / " + horaFin} />
                                    <FormInput id={"mesas"} text={"Mesa disponible"} className={"col-md-5 col-12 offset-md-0 offset-sm-1 col-sm-10 "}
                                        mostrarTodas={true} idSeccion={8} url={"evento/mesasDeUnEventoFiltradasPorHoraOrdenadasPorMesa"}
                                        params={paramsEventoTurno} setValue={setMesa} reload={reloadCount} />
                                    <FormInput id={"empresa1"} text={"Primera empresa"} className={"col-md-5 col-12 offset-sm-1 col-sm-10 offset-md-1"}
                                        mostrarTodas={true} idSeccion={10} items={props.empresas} setValue={setIdInscripcion1} value={idInscripcion1} />
                                    <FormInput id={"empresa2"} text={"Segunda empresa"} className={"col-md-5 col-12 offset-sm-1 col-sm-10  offset-md-0"}
                                        mostrarTodas={true} idSeccion={10} items={props.empresas} setValue={setIdInscripcion2} value={idInscripcion2} />
                                </div>

                            </div>
                            <BtnGuardarEdit zona={0} className={"row text-center py-5"} guardar={crearReunion} text={"Crear reunión"} />
                        </>
                        :
                        <p className='text-center mt-4 fw-bold'>Debe tener eventos para poder crear una reunión</p>
                }
                />
            </>
            }
        </>
    );
}

export default CrearReunion;